<template>
  <div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <img
              src="../../assets/images/avatar_default.png"
              class="c-avatar-img"
            />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>{{ $t(`label.account`) }}</strong>
      </CDropdownHeader>
      <CDropdownItem class="profile-information">
        <router-link :to="{ path: `/information-profile` }">
          <CIcon name="cil-user" />{{ $t("popup.label_title_profile") }}
        </router-link>
      </CDropdownItem>
      <CDropdownItem @click="showModal">
        <CIcon name="cil-lock-locked" />
        {{ $t("popup.label_title_change_password") }}
      </CDropdownItem>
      <CDropdownItem @click.prevent="logoutHandler()">
        <CIcon name="cil-account-logout" /> {{ $t(`label.logout`) }}
      </CDropdownItem>
    </CDropdown>

    <template>
      <b-modal ref="my-modal" hide-footer hide-header>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(handleChangePassword)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("commons.label_password_old") }}</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="password_old"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.password"
                    :placeholder="$t('placeholder.label_enter_password_old')"
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("commons.label_password_new") }}</label>
                <ValidationProvider
                  rules="required|min:6"
                  v-slot="{ errors }"
                  name="password_new"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.passwordNew"
                    :placeholder="$t('placeholder.label_enter_password_new')"
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("commons.label_password_confirm") }}</label>
                <ValidationProvider
                  rules="required|confirmed:password_new"
                  v-slot="{ errors }"
                  name="password_confirm"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.confirmPassword"
                    :placeholder="
                      $t('placeholder.label_enter_password_confirm')
                    "
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">{{
                $t("button.label_action_accept")
              }}</b-button>
              <span class="mr-2"></span>
              <b-button class="mt-3" variant="outline-danger" @click="hideModal"
                >{{ $t("button.label_action_cancel") }}
              </b-button>
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import firebase from "../../firebase";

export default {
  name: "HeaderDropdownAccount",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      itemsCount: 42,
      formChangePassword: {
        password: null,
        passwordNew: null,
        confirmPassword: null
      }
    };
  },
  methods: {
    ...mapActions("layout", ["toggleSidebarMobile", "toggleSidebarDesktop"]),

    ...mapActions("auth", ["logout", "refreshToken"]),

    showModal() {
      this.formChangePassword = {};
      this.$refs["my-modal"].show();
    },

    hideModal() {
      this.$refs["my-modal"].hide();
    },

    logoutHandler() {
      this.logout().then(() => {
        this.removeNotificationToken();
        this.$router.push({ name: "Login" });
      });
    },

    async removeNotificationToken() {
      let self = this;
      const messaging = firebase.messaging();
      messaging
        .requestPermission()
        .then(function() {
          return messaging.getToken();
        })
        .then(function(token) {
          self.$store.dispatch("auth/removeToken", {
            fcm_token: token
          });
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    async handleChangePassword() {
      this.$root.$loading.start();
      await this.$store
        .dispatch("auth/changePassword", this.formChangePassword)
        .then(() => {
          this.$root.$loading.finish();
          this.$toast(
            this.$t("popup.label_change_password_success"),
            this.$t("popup.label_title_change_password"),
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.hideModal();
          this.$router.push({ name: "Login" });
          this.formChangePassword = {};
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}

.profile-information a {
  color: #4f5d73;
  text-decoration: none;
}
</style>
